import React from 'react';
import PropTypes from 'prop-types';

// Import components
import Icon from '../shared/Icon/Icon';

const Intro = ({ setIsFormStarted }) => {
  const handleClick = () => {
    setIsFormStarted(true);
  };

  return (
    <div className="ds-col-1">
      <h1>Contact us</h1>
      <p>
        You’ll need to contact Transport for West Midlands if your enquiry is about information,
        journey planning and transport disruptions.
      </p>
      <p>
        You’ll need to contact your local council if your enquiry is about general council services.
        For example, bin collections and council tax.
      </p>

      <h2>Find who you need to contact</h2>
      <p>
        Answer questions and we&apos;ll direct you to the right team so we can respond to your query
        faster.
      </p>

      <button
        type="button"
        className="ds-btn ds-btn--start ds-m-t-xl ds-m-b-xl ds-col-1 ds-col-sm-auto"
        onClick={handleClick}
      >
        Start now
        <Icon className="ds-btn__icon ds-btn__icon--right" iconName="general-chevron-right" />
      </button>
    </div>
  );
};
Intro.propTypes = {
  setIsFormStarted: PropTypes.func.isRequired,
};
export default Intro;
